export default __webpack_public_path__ + "static/media/configr-positivo.cb87a2f2.svg";